export default "__VITE_ASSET__babad332__"